module.exports = __webpack_public_path__ + "static/img/Adam-Treloar.f67f1dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Adam-Treloar.jpg
// module id = c1fO
// module chunks = 0